import { FilterProps, LeftFilterProps } from 'types/Filters';
import clsx from 'clsx';

interface CheckboxListProps {
    options: LeftFilterProps[];
    section: string;
    dropdown: boolean;
    setSearchTerm?: React.Dispatch<React.SetStateAction<string>>;
    setLeftFilter: React.Dispatch<React.SetStateAction<FilterProps[]>>;
    updateHomepageFilter: (
        updatedOption: LeftFilterProps,
        filterId: string,
    ) => void;
}

export default function CheckboxList({
    options,
    section,
    dropdown,
    setSearchTerm,
    setLeftFilter,
    updateHomepageFilter,
}: CheckboxListProps) {
    const handleOptionClick = (
        clickedOption: LeftFilterProps,
        filterId: string,
    ) => {
        if (dropdown && setSearchTerm) {
            setSearchTerm('');
        }
        setLeftFilter((prevFilters) => {
            return prevFilters.map((filter) => {
                if (filter.id === filterId) {
                    return {
                        ...filter,
                        options: filter.options.map((option) => {
                            if (option.label === clickedOption.label) {
                                return {
                                    ...option,
                                    checked: !option.checked, // Toggle the checked status
                                };
                            }
                            return option;
                        }),
                    };
                }
                return filter;
            });
        });
        updateHomepageFilter(clickedOption, filterId);
    };

    return (
        <div className="space-y-8 max-h-52 overflow-y-scroll">
            {options
                .slice() // Create a copy of the options array
                .sort((a, b) =>
                    a.checked === b.checked ? 0 : a.checked ? -1 : 1,
                ) // Sort the copied array based on checked status
                .map((option, optionIdx) => (
                    <div
                        key={`${option.label}-div`}
                        className="flex justify-between"
                    >
                        <div
                            key={`${option.label}-checkbox`}
                            className={clsx(
                                dropdown &&
                                    'dropdown-options hover:bg-sea-blue-100 w-full',
                                'flex items-center',
                            )}
                        >
                            <input
                                id={`filter-${section}-${optionIdx}`}
                                name={`${section}[]`}
                                defaultValue={option.label}
                                type="checkbox"
                                checked={option.checked}
                                className="h-16 w-16 rounded-8 cursor-pointer border-faded-blue-400 text-true-blue focus:ring-indigo-500"
                                onChange={() =>
                                    handleOptionClick(option, section)
                                }
                            />
                            <label
                                htmlFor={`filter-${section}-${optionIdx}`}
                                className="ml-3 text-sm text-true-blue cursor-pointer"
                            >
                                {option.label}
                            </label>
                        </div>
                        {!dropdown && (
                            <label
                                htmlFor={`filter-${section}-${optionIdx}-count`}
                                className="ml-3 text-sm text-true-blue"
                            >
                                {option.count}
                            </label>
                        )}
                    </div>
                ))}
        </div>
    );
}
